import { fetchPolicies } from "./policyApi";
import { normalizePolicies } from "./policyNormalizer";
import { buildPolicyIndex } from "./policyIndex";
import { createEmbedding } from "./embeddingService";

export const bootstrapPolicies = async () => {
  console.log("🚀 bootstrapPolicies started");
  try {
    const policies = await fetchPolicies();
    console.log("📦 Policies from API:", policies.length, policies);

    if (!policies.length) {
      console.warn("⚠️ No policies returned from API.");
      return;
    }

    const chunks = normalizePolicies(policies);
    console.log("📝 Chunks created:", chunks.length);

    const indexed = await Promise.all(
      chunks.map(async (chunk) => ({
        ...chunk,
        embedding: await createEmbedding(chunk.text)
      }))
    );

    buildPolicyIndex(indexed);
    console.log("✅ Policy index ready:", indexed.length, "chunks from", policies.length, "policies");
  } catch (err) {
    console.error("❌ Policy bootstrap failed:", err);
  }
};